const namespace = 'bravissimo/timers';

export const START_TIMER = `${namespace}/START_TIMER`;
export const CANCEL_TIMER = `${namespace}/CANCEL_TIMER`;

export const CLOSE_POPOVER_BAG_TIMER = `${namespace}/timers/close-popover-bag`;
